/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type PagesEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const pagesEntrypoint: EntryPoint<PagesEntrypointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<PagesEntrypointComponent>(
		/* webpackChunkName: "async-business-pages-entrypoint" */ './JiraBusinessPagesAppMemo.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
